<template>
  <div>
    <h6 :class="question.visibility == 'admin_only' ? 'text-danger' : ''">
      {{ question.label }} {{ question.required ? '*' : '' }}
      <small v-if="question.visibility == 'admin_only'" :title="trans('visible_only_administrators')" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
    </h6>
    <div :class="question.visibility == 'admin_only' ? 'mb-2 text-danger' : 'mb-2'" v-html="question.description"></div>
    <b-form-group>
      <b-form-select
        :size="size"
        :name="question.slug"
        v-model="answer"
        :required="question.required"
        :state="!!errors ? false : null"
        :options="options"
        :style="question.visibility == 'admin_only' ? 'border-color: #F57A00;' : ''"
        :disabled="busy || isLocked"
        @change="$emit('clear-error', question.slug)"
      ></b-form-select>
      <b-form-text v-if="question.options.locked">
        {{ trans('question_locked_except_admin') }}
      </b-form-text>
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      value: String, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      let value = this.value
      if ((value === null || value === undefined) && this.question.options.values_from_question) {
        value = this.question.options.default
      }
      return {
        trans: trans,
        busy: false,
        error: null,
        answer: value,
        form_question_answer_values: null,
      }
    },
    computed: {
      values() {
        let values = (this.question.options.values || []).map(value => {
          return {value: value, text: value}
        })
        values.unshift({
          value: null,
          text: this.question.placeholder || '',
          disabled: this.question.required,
          selected: !this.answer
        })
        return values
      },
      options() {
        if (!this.question.options.values_from_question)
          return this.values
        if (!this.question.options.recipient_form_id ||
          !this.question.options.form_question_id)
          return []
        let options = _.map(this.form_question_answer_values || [], value => {
          return {value: value, text: value}
        })
        options.unshift({
          value: null,
          text: this.question.placeholder || '',
          disabled: this.question.required,
          selected: !this.answer
        })
        return options
      },
      isLocked() {
        return this.question.options.locked &&
          (!this.organization || !this.organization.auth_user)
      },
    },
    watch: {
      answer() {
        if (this.answer !== this.value) this.$emit('input', this.answer)
      },
      value() {
        this.answer = this.value
      },
      question() {
        let value = this.value
        if ((value === null || value === undefined) && this.question.options.values_from_question) {
          value = this.question.options.default
        }
        this.answer = value
        if (this.question.options.values_from_question) {
          if (!!this.question.options.form_question_id) {
            this.loadFormQuestionAnswers()
          } else {
            this.form_question_answer_values = []
          }
        }
      },
    },
    methods: {
      loadFormQuestionAnswers() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/checkout_form/list_question_answer_values/${this.question.options.form_question_id}`
        if (!!this.question.options.form_question2_id)
          url += `/${this.question.options.form_question2_id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.form_question_answer_values = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window['formSelectQuestion_' + (!!this.form_answer ? this.form_answer.id || '' : '')] = this
      if (this.question.options.values_from_question &&
        !!this.question.options.form_question_id)
        this.loadFormQuestionAnswers()
    },
  }
</script>